export default __webpack_public_path__ + "static/media/Picture3.f8e7ed98.png";